import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

// Attach token on every request from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mrva_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401 handler
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("mrva_token");
      localStorage.removeItem("mrva_user");
    }
    return Promise.reject(err);
  }
);

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const token = localStorage.getItem("mrva_token");
  const res = await axios.post(`${API_BASE}/upload/image`, fd, {
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data.url;
};
